<div class="pointer">
  <mat-form-field appearance="outline" class="w-100">
    <mat-label>{{ label }}</mat-label>
    <input matInput type="number" [formControl]="control" min="0" max="100" step="1" (keydown)="blockInvalidKeys($event)" (paste)="onPaste($event)" />
    <mat-error *ngIf="control.hasError('required')"> Valore obbligatorio </mat-error>
    <mat-error *ngIf="control.hasError('min') || control.hasError('max')"> Inserire un valore tra 0 e 100 </mat-error>
    <mat-error *ngIf="control.hasError('pattern')"> Solo numeri interi consentiti </mat-error>
    <span matSuffix class="pe-2"> % </span>
  </mat-form-field>
</div>
